import gql from "graphql-tag";

export const CHECK_MANDATE_PNVT = gql`
  query CheckMandatePnvt {
    checkMandatePnvt
  }
`;
